// 审核状态字典（对应 applyStatus Integer）
export const APPROVAL_STATUS_DICT = [
  { label: '待审核', value: 1 },
  { label: '已通过', value: 2 },
  { label: '已拒绝', value: 3 },
]

// 申请方式字典
export const APPLICATION_METHOD_DICT = [
  { label: '小程序申请', value: 'miniprogram' },
  { label: 'PC端申请', value: 'pc' },
  { label: '手动录入', value: 'manual' },
]

// 维修类型字典
export const MAINTENANCE_TYPE_DICT = [
  { label: '紧急维修', value: 'emergency' },
  { label: '计划维修', value: 'planned' },
  { label: '预防性维修', value: 'preventive' },
  { label: '故障维修', value: 'breakdown' },
]

// 紧急程度字典（对应 urgencyLevel Integer）
export const URGENCY_LEVEL_DICT = [
  { label: '普通', value: 1 },
  { label: '紧急', value: 2 },
  { label: '非常紧急', value: 3 },
]



